module.exports = __webpack_public_path__ + "static/img/com1.cad2564.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/product/components/imgs/com1.jpg
// module id = jAAr
// module chunks = 1